import styled from "styled-components";

export const DateFilterContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const DateFilterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: ${(props) =>
    props.$active ? "var(--accent)" : "var(--surface)"};
  color: ${(props) => (props.$active ? "white" : "var(--text-secondary)")};
  border: 1px solid
    ${(props) => (props.$active ? "var(--accent)" : "var(--accent-light)")};
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  min-width: 200px;
  transition: all 0.2s ease;
  max-height: 38px;

  &:hover {
    background: ${(props) =>
      props.$active ? "var(--accent)" : "var(--accent-light)"};
  }

  span {
    flex: 1;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const DateFilterDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--surface);
  border: 1px solid var(--accent-light);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 16px;
  z-index: 1000;
  margin-top: 4px;
`;

export const DateInputGroup = styled.div`
  margin-bottom: 12px;

  &:last-of-type {
    margin-bottom: 16px;
  }
`;

export const DateLabel = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const DateInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid var(--accent-light);
  border-radius: 6px;
  background: var(--background);
  color: var(--text-primary);
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: var(--accent);
    box-shadow: 0 0 0 2px var(--accent-light);
  }

  &::-webkit-calendar-picker-indicator {
    cursor: pointer;
    filter: ${(props) => (props.theme === "dark" ? "invert(1)" : "none")};
  }
`;

export const DateFilterActions = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`;

export const ClearButton = styled.button`
  background: transparent;
  color: var(--surface);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  margin-left: 10px;
  transition: all 0.2s ease;

  &:hover {
    color: var(--error);
    border-color: var(--error);
  }
`;

export const ApplyButton = styled.button`
  padding: 6px 16px;
  background: var(--accent);
  color: white;
  border: 1px solid var(--accent);
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.2s ease;

  &:hover {
    background: var(--accent-hover);
  }
`;
